import React from 'react';
import PropTypes from 'prop-types';
import { styles } from '4all-ui/styles';

const AlertIcon = ({ size, color, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 90 90"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className={`alert-icon ${className}`}
  >
    <defs>
      <path
        d="M45,79.5 C42.5147186,79.5 40.5,77.4852814 40.5,75 C40.5,72.5147186 42.5147186,70.5 45,70.5 C47.4852814,70.5 49.5,72.5147186 49.5,75 C49.5,77.4852814 47.4852814,79.5 45,79.5 Z M42,32.2500007 C42,31.00736 43.3431458,30.0000007 45,30.0000007 C46.6568542,30.0000007 48,31.00736 48,32.2500007 L48,63.7500007 C48,64.9926414 46.6568542,66.0000007 45,66.0000007 C43.3431458,66.0000007 42,64.9926414 42,63.7500007 L42,32.2500007 Z M89.6832816,85.6583592 C90.6806332,87.6530625 89.2301461,90 87,90 L3,90 C0.769853937,90 -0.680633212,87.6530625 0.316718427,85.6583592 L42.3167184,1.65835921 C43.4222912,-0.552786405 46.5777088,-0.552786405 47.6832816,1.65835921 L89.6832816,85.6583592 Z M82.145898,84 L45,9.70820393 L7.85410197,84 L82.145898,84 Z"
        id="path-alert-1"
      />
    </defs>
    <g id="Variações-Globais" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="1.6-Variações-Globais" transform="translate(-638.000000, -329.000000)">
        <g id="Group-4" transform="translate(502.000000, 289.000000)">
          <g id="icon/alert/" transform="translate(136.000000, 40.000000)">
            <mask id="mask-alert-2" fill="white">
              <use xlinkHref="#path-alert-1" />
            </mask>
            <use id="alert" fill="#979797" fillRule="evenodd" xlinkHref="#path-alert-1" />
            <g
              id="colors/portal_único/red"
              mask="url(#mask-alert-2)"
              fill={color}
              fillRule="evenodd"
            >
              <rect id="color" x="0" y="0" width="90" height="90" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

AlertIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
};

AlertIcon.defaultProps = {
  color: styles.colors.DANGER_COLOR,
  size: '90px',
  className: '',
};

export default AlertIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Alert/index.js